import { WrapProject } from '../types'

export const wrapProjects: WrapProject[] = [
  // Brand Identity
  {
    id: 6,
    title: 'Smoove Move Logistics',
    description: 'Complete brand transformation with web design',
    category: 'Brand Identity',
    images: [
      '/case-studies/smoove-move/logo.png',
      '/case-studies/smoove-move/icon.png',
      '/case-studies/smoove-move/ASTRO.png'
    ],
    isCaseStudy: true,
    caseStudySlug: 'smoove-move'
  },
  {
    id: 7,
    title: 'GalaPay',
    description: 'Complete fintech brand identity system',
    category: 'Brand Identity',
    images: [
      '/case-studies/galapay/logo-full.png',
      '/case-studies/galapay/logo-wordmark.png',
      '/case-studies/galapay/logo-icon.png'
    ],
    isCaseStudy: true,
    caseStudySlug: 'galapay'
  },
  {
    id: 8,
    title: 'The Life Gallery',
    description: 'Psychedelic brand identity and merchandise system',
    category: 'Brand Identity',
    images: [
      '/folio2/tlgposter.PNG',
      '/folio2/tlg2.PNG',
      '/folio2/tlg3.PNG',
      '/folio2/tlg4.PNG',
      '/folio2/tlg5.PNG',
      '/folio2/tlg6.PNG',
      '/starlife.png',
      '/folio2/blustar.png',
      '/folio2/starlife3.PNG',
      '/folio2/iceup.PNG',
      '/egle.png',
      '/starneon.png',
      '/folio2/star4.png',
      '/folio2/genki.png',
      '/folio2/genki2.png'
    ]
  },

  // Web Design
  {
    id: 200,
    title: 'Smoove Move Logistics',
    description: 'Custom website design and development',
    category: 'Web Design',
    images: [
      '/case-studies/smoove-move/logo.png'
    ],
    externalUrl: 'https://smoovemovelogistics.com'
  },
  {
    id: 201,
    title: 'GalaPay',
    description: 'High-performance fintech landing page',
    category: 'Web Design',
    images: [
      '/case-studies/galapay/logo-full.png'
    ],
    externalUrl: 'https://galapay.biz'
  },

  // Vehicle Wraps
  {
    id: 100,
    title: 'Elite Auto Detailing',
    description: 'Mobile auto detailing wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/elite.png'],
    review: {
      rating: 5,
      text: "chipahauk's design work was clean, professional and exactly what I had in mind. They really understood my vision and delivered a design that perfectly represents my business.",
      reviewer: "Elite Auto Detailing",
      timeAgo: "4 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 101,
    title: 'Let\'s Have A Field Day',
    description: 'Party rental trailer wrap',
    category: 'Vehicle Wraps',
    images: [
      '/folio/fieldday1.png',
      '/folio/fieldday2.png',
      '/folio/fieldday3.png'
    ],
    review: {
      rating: 5,
      text: "The design chipahauk created is bright, catches a lot of attention, and gets us tons of business! People notice our trailer everywhere we go.",
      reviewer: "Let's Have A Field Day",
      timeAgo: "6 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 102,
    title: 'Bow Wow Fit Club',
    description: 'Mobile dog gym wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/bowwow.png'],
    review: {
      rating: 5,
      text: "chipahauk got the pink shade perfectly, exactly what I wanted! As a new business, I needed a strong brand and their design work helped me establish that.",
      reviewer: "Bow Wow Fit Club",
      timeAgo: "4 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 103,
    title: 'B.A.R.K. Institute',
    description: 'Dog training facility wrap',
    category: 'Vehicle Wraps',
    images: [
      '/folio/bark1.png',
      '/folio/bark2.png',
      '/folio/bark3.png',
      '/folio/bark4.png'
    ],
    review: {
      rating: 5,
      text: "chipahauk took our vision and brought it to life with incredible attention to detail. The design perfectly captures our brand's energy and professionalism.",
      reviewer: "B.A.R.K. Institute",
      timeAgo: "2 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 104,
    title: 'Optimum Plumbing',
    description: 'Plumbing & heating service wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/optimum.png'],
    review: {
      rating: 5,
      text: "chipahauk did an awesome job on our graphic design project. Their process from initial concept through final designs was seamless and super professional.",
      reviewer: "Optimum Plumbing",
      timeAgo: "5 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 105,
    title: 'The Grill Boys',
    description: 'Grill cleaning service wrap',
    category: 'Vehicle Wraps',
    images: [
      '/folio/gb1.png',
      '/folio/gb2.png'
    ],
    review: {
      rating: 5,
      text: "chipahauk absolutely crushed our design project! The graphics they created were incredible. Clean, bold, and exactly how we envisioned it.",
      reviewer: "The Grill Boys",
      timeAgo: "3 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 106,
    title: 'Titan Garage Doors',
    description: 'Garage door service vehicle wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/titan.png'],
    review: {
      rating: 5,
      text: "chipahauk did an amazing job with our wrap design. They provided first class service on the design and follow up. I'd put their final product up against anyone.",
      reviewer: "Titan Garage Doors",
      timeAgo: "3 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 107,
    title: 'Cannabis Philosophy',
    description: 'Delivery trailer wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/canna1.png'],
    review: {
      rating: 5,
      text: "chipahauk is amazing at design. They took our rough concept and brought it to life way better than we even expected.",
      reviewer: "Cannabis Philosophy",
      timeAgo: "3 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 108,
    title: 'Refined Wine',
    description: 'Wine delivery service wrap',
    category: 'Vehicle Wraps',
    images: ['/folio/refinedwine.png'],
    review: {
      rating: 5,
      text: "The sophistication and elegance chipahauk brought to our brand is unmatched. They created a design that perfectly represents our premium wine service.",
      reviewer: "Refined Wine",
      timeAgo: "2 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 109,
    title: 'Big Belly Bagels',
    description: 'Food service van wrap',
    category: 'Vehicle Wraps',
    images: [
      '/folio/bigbelly1.png',
      '/folio/bigbelly2.png',
      '/folio/bigbelly3.png'
    ],
    review: {
      rating: 5,
      text: "It's big, it's loud, and it's professional! I was amazed at how chipahauk took regular images and turned them into HD graphics that printed perfectly.",
      reviewer: "Big Belly Bagels",
      timeAgo: "5 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 110,
    title: 'KleanUp',
    description: 'Cleaning service wrap',
    category: 'Vehicle Wraps',
    images: [
      '/folio/klean1.png',
      '/folio/klean2.png'
    ],
    review: {
      rating: 5,
      text: "Working with chipahauk was amazing. The design process was seamless, no headaches and resulted in an absolutely incredible final product.",
      reviewer: "KleanUp",
      timeAgo: "3 months ago",
      reviewCount: "",
      link: ""
    }
  },
  {
    id: 111,
    title: 'You Scream Ice Cream',
    description: 'Food truck wrap design',
    category: 'Vehicle Wraps',
    images: [
      '/folio/youscream1.png',
      '/folio/youscream2.png'
    ],
    review: {
      rating: 5,
      text: "chipahauk transformed our boring ice cream truck into something classy and modern! We absolutely loved the character mascot they created for us.",
      reviewer: "You Scream Ice Cream",
      timeAgo: "6 months ago",
      reviewCount: "",
      link: ""
    }
  }
]
